import { createAsyncThunk, createSlice } from "@reduxjs/toolkit";
import dayjs from "dayjs";
import { setupAPIs } from "../setupUtils";
import { saveAs } from "file-saver";

const initialCustomerGroup = {
   isEdit: true,
   isLoading: false,

   countries: [],
   country: "",
   countryID: "",

   customerLevels: [],
   customerLevel: "",
   customerLevelID: "",

   customerTypes: [],
   customerType: "",
   customerTypeCode: "",

   customerGroups: [],
   customerGroupName: "",
   customerGroupID: "",
   customerGroupDetail: null,

   relShipLevels: [],
   relShipLevel: "All",
   relShipLevelID: 0,

   customerName: "",

   activeCustomer: false,
   newCustomer: false,

   customers: [],
   selCustomers: [],

   files: [],

   editCGName: "",

   editFromDate: dayjs().add(1, "day"),
   editToDate: dayjs("2099-12-31T00:00:00.000Z"),

   status: "None",

   createCGName: "",

   createFromDate: dayjs().add(1, "day"),
   createToDate: dayjs("2099-12-31T00:00:00.000Z"),
   createIndDateUpdated: false,
   createEditStartEndDateModalOpened: false,

   createMessage: "",
   createMessageSeverity: "",
   createMessageOpen: false,

   response: null,

   createComments: "",
   editComments: "",

   popUpMsg: "",
   popUpSeverity: "",
   popUpOpen: false,
   is_customer_refresh : false,
   is_refresh : false
};

export const getUserCountries = createAsyncThunk(
   "customerGroup/getUserCountries",
   async (obj, thunkAPI) => {
      const data = JSON.parse(localStorage.getItem("data"));
      const token = data.token;
      let headers = new Headers();
      if (token) {
         headers.append("Authorization", `Bearer ${token}`);
      }
      const options = {
         headers,
      };
      const url = setupAPIs.getUserCountries + `userid=${data.userID}`;
      const response = await fetch(url, options);
      const jsonData = await response.json();
      return jsonData;
   }
);

export const getCGRefData = createAsyncThunk(
   "customerGroup/getCGRefData",
   async (obj, thunkAPI) => {
      const data = JSON.parse(localStorage.getItem("data"));
      const token = data.token;
      const { countryID } = obj;
      let headers = new Headers();
      if (token) {
         headers.append("Authorization", `Bearer ${token}`);
      }
      const options = {
         headers,
      };
      const url = setupAPIs.getCGRefData + `countryId=${countryID}`;
      const response = await fetch(url, options);
      const jsonData = await response.json();
      return jsonData;
   }
);

export const getCGForCountry = createAsyncThunk(
   "customerGroup/getCGForCountry",
   async ({ countryID, customerTypeCode, customerGroupName }, thunkAPI) => {
      const data = JSON.parse(localStorage.getItem("data"));
      const token = data.token;
      let headers = new Headers();
      if (token) {
         headers.append("Authorization", `Bearer ${token}`);
      }
      const options = {
         headers,
      };
      const url =
         setupAPIs.getCGForCountry +
         `CountryID=${countryID}&CustomerTypeCode=${customerTypeCode}&CustomerGroupName=${customerGroupName}`;
      const response = await fetch(url, options);
      const jsonData = await response.json();
      return jsonData;
   }
);

export const getCGDetail = createAsyncThunk(
   "customerGroup/getCGDetail",
   async ({ customerGroupID }, thunkAPI) => {
      const data = JSON.parse(localStorage.getItem("data"));
      const token = data.token;
      let headers = new Headers();
      if (token) {
         headers.append("Authorization", `Bearer ${token}`);
      }
      const options = {
         headers,
      };
      const url = setupAPIs.getCGDetail + `CustomerGroupID=${customerGroupID}`;
      const response = await fetch(url, options);
      const jsonData = await response.json();
      return jsonData;
   }
);

export const getRelshipLevel = createAsyncThunk(
   "customerGroup/getRelshipLevel",
   async (obj, thunkAPI) => {
      const data = JSON.parse(localStorage.getItem("data"));
      const token = data.token;
      let headers = new Headers();
      if (token) {
         headers.append("Authorization", `Bearer ${token}`);
      }
      const options = {
         headers,
      };
      const url = setupAPIs.getRelshipLevel;
      const response = await fetch(url, options);
      const jsonData = await response.json();
      return jsonData;
   }
);

export const getCustomers = createAsyncThunk(
   "customerGroup/getCustomers",
   async (
      {
         countryID,
         customerTypeCode,
         customerLevelID,
         customerName,
         activeCustomer,
         relShipLevelID,
         newCustomer,
      },
      thunkAPI
   ) => {
      const data = JSON.parse(localStorage.getItem("data"));
      const token = data.token;
      let headers = new Headers();
      if (token) {
         headers.append("Authorization", `Bearer ${token}`);
      }
      const options = {
         headers,
      };
      const url =
         setupAPIs.getCustomers +
         `CntryID=${countryID}&CstTypeCode=${customerTypeCode}&CstLvlCode=${customerLevelID}&CstName=${customerName}&ActiveCst=${activeCustomer}&trstLvl=${relShipLevelID}&newCustomer=${
            newCustomer ? 3 : 0
         }`;
      const response = await fetch(url, options);
      const jsonData = await response.json();
      return jsonData;
   }
);

export const getCustomersAuto = createAsyncThunk(
   "customerGroup/getCustomersAuto",
   async (
      {
         countryID,
         customerTypeCode,
         customerLevelID,
         customerName,
         activeCustomer,
         relShipLevelID,
         newCustomer,
      },
      thunkAPI
   ) => {
      const data = JSON.parse(localStorage.getItem("data"));
      const token = data.token;
      let headers = new Headers();
      if (token) {
         headers.append("Authorization", `Bearer ${token}`);
      }
      const options = {
         headers,
      };
      const url =
         setupAPIs.getCustomers +
         `CntryID=${countryID}&CstTypeCode=${customerTypeCode}&CstLvlCode=${customerLevelID}&CstName=${customerName}&ActiveCst=${activeCustomer}&trstLvl=${relShipLevelID}&newCustomer=${
            newCustomer ? 3 : 0
         }`;
      const response = await fetch(url, options);
      const jsonData = await response.json();
      return jsonData;
   }
);

export const submitCustomerGroup = createAsyncThunk(
   "customerGroup/submitCustomerGroup",
   async (obj, thunkAPI) => {
      const data = JSON.parse(localStorage.getItem("data"));
      const token = data.token;
      const url = setupAPIs.submitCustomerGroup;
      try {
         const response = await fetch(url, {
            method: "POST",
            headers: {
               "Content-Type": "application/json",
               Authorization: `Bearer ${token}`,
               Accept: "application/json",
            },
            body: JSON.stringify(obj),
         });
         const jsonData = await response.json();
         return jsonData;
      } catch (error) {
         console.error("Error: ", error);
      }
   }
);

export const saveCustomerGroup = createAsyncThunk(
   "customerGroup/saveCustomerGroup",
   async (obj, thunkAPI) => {
      const data = JSON.parse(localStorage.getItem("data"));
      const token = data.token;
      const url = setupAPIs.saveCustomerGroup;
      try {
         const response = await fetch(url, {
            method: "POST",
            headers: {
               "Content-Type": "application/json",
               Authorization: `Bearer ${token}`,
               Accept: "application/json",
            },
            body: JSON.stringify(obj),
         });
         const jsonData = await response.json();
         return jsonData;
      } catch (error) {
         console.error("Error: ", error);
      }
   }
);

export const cloneCustomerGroup = createAsyncThunk(
   "customerGroup/cloneCustomerGroup",
   async (obj, thunkAPI) => {
      const data = JSON.parse(localStorage.getItem("data"));
      const token = data.token;
      const url = setupAPIs.cloneCustomerGroup;
      try {
         const response = await fetch(url, {
            method: "POST",
            headers: {
               "Content-Type": "application/json",
               Authorization: `Bearer ${token}`,
               Accept: "application/json",
            },
            body: JSON.stringify(obj),
         });
         const jsonData = await response.json();
         return jsonData;
      } catch (error) {
         console.error("Error: ", error);
      }
   }
);

export const uploadFileForCustomerGroup = createAsyncThunk(
   "customerGroup/uploadFileForCustomerGroup",
   async (formdata, thunkAPI) => {
      const data = JSON.parse(localStorage.getItem("data"));
      const token = data.token;
      const url = setupAPIs.uploadFileForCustomerGroup;
      try {
         const response = await fetch(url, {
            method: "POST",
            headers: {
               Authorization: `Bearer ${token}`,
               Accept: "application/json",
            },
            body: formdata,
         });
         const jsonData = await response.json();
         return jsonData;
      } catch (error) {
         console.error("Error: ", error);
      }
   }
);

export const downloadAttachment = createAsyncThunk(
   "customerGroup/downloadAttachment",
   async (obj, thunkAPI) => {
      const data = JSON.parse(localStorage.getItem("data"));
      const token = data.token;
      const url = setupAPIs.downloadAttachment + `fileName=${obj.fileName}`;
      try {
         const response = await fetch(url, {
            method: "GET",
            headers: {
               Authorization: `Bearer ${token}`,
               Accept: "application/json",
            },
         });
         const res = await response.blob();
         const fileName = `${obj.fileName}`;
         saveAs(res, fileName);
         return res;
         } catch (error) {
            console.error("Error: ", error);
         }
      }     
);

const customerGroupSetupSlice = createSlice({
   name: "customerGroupSetup",
   initialState: initialCustomerGroup,
   reducers: {
      setCGState: {
         prepare(stateName, stateValue) {
            return {
               payload: { stateName, stateValue },
            };
         },
         reducer(state, action) {
            const { stateName, stateValue } = action.payload;
            state[stateName] = stateValue;
         },
      },
      resetAllStates(state, action) {
         if (action.payload.edit) {
            state.isEdit = true;
         }
         state.isLoading = false;
         state.country = "";
         state.countryID = "";

         // state.customerLevels = [];
         state.customerLevel = "";
         state.customerLevelID = "";

         // state.customerTypes = [];
         state.customerType = "";
         state.customerTypeCode = "";

         // state.customerGroups = [];
         state.customerGroupName = "";
         state.customerGroupID = "";
         state.customerGroupDetail = null;

         // state.relShipLevels = [];
         state.relShipLevel = "All";
         state.relShipLevelID = 0;

         state.customerName = "";

         state.activeCustomer = false;
         state.newCustomer = false;

         state.customers = [];
         state.selCustomers = [];

         state.files = [];
         state.editCGName = "";
         state.editFromDate = dayjs().add(1, "day");
         state.editToDate = dayjs("2099-12-31T00:00:00.000Z");
         state.status = "None";
         state.createCGName = "";
         state.createFromDate = dayjs().add(1, "day");
         state.createToDate = dayjs("2099-12-31T00:00:00.000Z");
         state.createIndDateUpdated = false;
         state.createEditStartEndDateModalOpened = false;
         state.response = null;
         state.createMessage = "";
         state.createMessageSeverity = "";
         state.createMessageOpen = false;
         state.popUpMsg = "";
         state.popUpSeverity = "";
         state.popUpOpen = false;
         state.createComments = "";
      },
      addFile(state, action) {
         console.log(action.payload);
         const updatedFiles = [...state.files, action.payload];
         console.log(updatedFiles);
         state.files = updatedFiles;
      },
      deleteFile(state, action) {
         const { filePath } = action.payload;
         const updatedFiles = state.files.filter(
            (file) => file.filePath !== filePath
         );
         state.files = updatedFiles;
      },
   },
   extraReducers: (builder) => {
      builder
         .addCase(getUserCountries.pending, (state, action) => {
            state.isLoading = true;
         })
         .addCase(getUserCountries.fulfilled, (state, action) => {
            state.isLoading = false;
            state.countries = action.payload;
         })
         .addCase(getUserCountries.rejected, (state, action) => {
            state.isLoading = false;
            console.error("Error from GetUserCountries", action.error.message);
         })

         .addCase(getCGRefData.pending, (state, action) => {
            state.isLoading = true;
         })
         .addCase(getCGRefData.fulfilled, (state, action) => {
            state.isLoading = false;
            state.customerLevels = action.payload.customerLevels;
            state.customerTypes = action.payload.customerTypes;
         })
         .addCase(getCGRefData.rejected, (state, action) => {
            state.isLoading = false;
            console.error("Error from getCGRefData", action.error.message);
         })

         .addCase(getCGForCountry.pending, (state, action) => {
            state.isLoading = true;
         })
         .addCase(getCGForCountry.fulfilled, (state, action) => {
            state.isLoading = false;
            state.customerGroups = action.payload;
            if (action.payload.length === 0) {
               state.popUpMsg = "No customer group found.";
               state.popUpSeverity = "info";
               state.popUpOpen = true;
            }
         })
         .addCase(getCGForCountry.rejected, (state, action) => {
            state.isLoading = false;
            console.error("Error from getCGForCountry", action.error.message);
         })

         .addCase(getCGDetail.pending, (state, action) => {
            state.isLoading = true;
         })
         .addCase(getCGDetail.fulfilled, (state, action) => {
            state.isLoading = false;
            state.customerGroupDetail = action.payload;
         })
         .addCase(getCGDetail.rejected, (state, action) => {
            state.isLoading = false;
            console.error("Error from getCGDetail", action.error.message);
         })

         .addCase(getRelshipLevel.pending, (state, action) => {
            state.isLoading = true;
         })
         .addCase(getRelshipLevel.fulfilled, (state, action) => {
            state.isLoading = false;
            state.relShipLevels = action.payload;
         })
         .addCase(getRelshipLevel.rejected, (state, action) => {
            state.isLoading = false;
            console.error("Error from getRelshipLevel", action.error.message);
         })

         .addCase(getCustomers.pending, (state, action) => {
            state.isLoading = true;
         })
         .addCase(getCustomers.fulfilled, (state, action) => {
            state.isLoading = false;
            if (action.payload.length !== 0) {
               if (state.selCustomers.length === 0) {
                  state.customers = action.payload;
               } else {
                  let filteredList = [];
                  let list = action.payload;
                  for (let i = 0; i < list.length; ++i) {
                     const customer = list[i];
                     let item = state.selCustomers.find(
                        (item) => item.customerID === customer.customerID
                     );
							if(state.customerLevelID === 'SH'){
								if(!item){
									item = state.selCustomers.find(
										(item) => item.sapCustomerNumber === customer.sapCustomerNumber
									);
								}
							}                      
                     if (!item) {
                        filteredList.push(customer);
                     }
                  }
                  state.customers = filteredList;
               }
            } else {
               if (state.isEdit === true) {
                  state.customers = [];
                  state.popUpMsg = "No customers found.";
                  state.popUpSeverity = "info";
                  state.popUpOpen = true;
               } else {
                  state.customers = [];
                  state.createMessage = "No customers found.";
                  state.createMessageSeverity = "info";
                  state.createMessageOpen = true;
               }
            }
         })
         .addCase(getCustomers.rejected, (state, action) => {
            state.isLoading = false;
            console.error("Error from getCustomers", action.error.message);
         })

         .addCase(getCustomersAuto.pending, (state, action) => {
            state.isLoading = true;
         })
         .addCase(getCustomersAuto.fulfilled, (state, action) => {
            state.isLoading = false;
            state.customers = action.payload;

            const min = 0;
            const max = 219;
            const indexes = [
               Math.floor(Math.random() * (max - min + 1)) + min,
               Math.floor(Math.random() * (max - min + 1)) + min,
               Math.floor(Math.random() * (max - min + 1)) + min,
            ];

            const selectedCustomers = [
               state.customers[indexes[0]],
               state.customers[indexes[1]],
               state.customers[indexes[2]],
            ];
            state.selCustomers = selectedCustomers;
         })
         .addCase(getCustomersAuto.rejected, (state, action) => {
            state.isLoading = false;
            console.error("Error from getCustomers", action.error.message);
         })

         .addCase(submitCustomerGroup.pending, (state, action) => {
            state.isLoading = true;
         })
         .addCase(submitCustomerGroup.fulfilled, (state, action) => {
            
            state.response = action.payload;
            if (state.isEdit === false) {
               if (typeof state.response === "string") {
                  state.createMessage = state.response;
                  state.createMessageSeverity = "error";
               } else if (typeof state.response === "object") {
                  state.createMessage = "Customer group submitted successfully";
                  state.createMessageSeverity = "success";
               } else {
                  state.createMessage =
                     "Threr is some error in submitting customer group";
                  state.createMessageSeverity = "error";
               }
               state.createMessageOpen = true;
            } else {
               if (typeof state.response === "string") {
                  state.popUpMsg = state.response;
                  state.popUpSeverity = "error";
               } else if (typeof state.response === "object") {
                  state.popUpMsg = "Customer group submitted successfully";
                  state.popUpSeverity = "success";
               } else {
                  state.popUpMsg =
                     "Threr is some error in submitting customer group";
                  state.popUpSeverity = "error";
               }
               state.popUpOpen = true;
            }
            state.isLoading = false;
         })
         .addCase(submitCustomerGroup.rejected, (state, action) => {
            state.isLoading = false;
            console.error(
               "Error from submitCustomerGroup",
               action.error.message
            );
         })

         .addCase(saveCustomerGroup.pending, (state, action) => {
            state.isLoading = true;
         })
         .addCase(saveCustomerGroup.fulfilled, (state, action) => {
            state.isLoading = false;
            state.response = action.payload;
            if (state.isEdit === false) {
               if (typeof state.response === "string") {
                  state.createMessage = state.response;
                  state.createMessageSeverity = "info";
               } else if (typeof state.response === "object") {
                  state.createMessage = "Customer group saved successfully";
                  state.createMessageSeverity = "success";
               } else {
                  state.createMessage =
                     "Threr is some error in saving customer group";
                  state.createMessageSeverity = "error";
               }
               state.createMessageOpen = true;
            } else {
               if (typeof state.response === "string") {
                  state.popUpMsg = state.response;
                  state.popUpSeverity = "info";
               } else if (typeof state.response === "object") {
                  state.popUpMsg = "Customer group saved successfully";
                  state.popUpSeverity = "success";
               } else {
                  state.popUpMsg =
                     "Threr is some error in saving customer group";
                  state.popUpSeverity = "error";
               }
               state.popUpOpen = true;
            }
         })
         .addCase(saveCustomerGroup.rejected, (state, action) => {
            state.isLoading = false;
            console.error("Error from saveCustomerGroup", action.error.message);
         })

         .addCase(cloneCustomerGroup.pending, (state, action) => {
            state.isLoading = true;
         })
         .addCase(cloneCustomerGroup.fulfilled, (state, action) => {
            state.isLoading = false;
            state.response = action.payload;
            if (state.isEdit === false) {
               if (typeof state.response === "string") {
                  state.createMessage = state.response;
                  state.createMessageSeverity = "info";
               } else if (typeof state.response === "object") {
                  state.createMessage = "Customer group cloned successfully";
                  state.createMessageSeverity = "success";
               } else {
                  state.createMessage =
                     "Threr is some error in cloning customer group";
                  state.createMessageSeverity = "error";
               }
               state.createMessageOpen = true;
            } else {
               if (typeof state.response === "string") {
                  state.popUpMsg = state.response;
                  state.popUpSeverity = "info";
               } else if (typeof state.response === "object") {
                  state.popUpMsg = "Customer group cloned successfully";
                  state.popUpSeverity = "success";
               } else {
                  state.popUpMsg =
                     "Threr is some error in cloning customer group";
                  state.popUpSeverity = "error";
               }
               state.popUpOpen = true;
            }
         })
         .addCase(cloneCustomerGroup.rejected, (state, action) => {
            state.isLoading = false;
            console.error(
               "Error from cloneCustomerGroup",
               action.error.message
            );
         })

         .addCase(uploadFileForCustomerGroup.pending, (state, action) => {
            state.isLoading = true;
         })
         .addCase(uploadFileForCustomerGroup.fulfilled, (state, action) => {
            state.isLoading = false;
         })
         .addCase(uploadFileForCustomerGroup.rejected, (state, action) => {
            state.isLoading = false;
            console.error(
               "Error from uploadFileForCustomerGroup",
               action.error.message
            );
         })

         .addCase(downloadAttachment.pending, (state, action) => {
            state.isLoading = true;
         })
         .addCase(downloadAttachment.fulfilled, (state, action) => {
            state.isLoading = false;
         })
         .addCase(downloadAttachment.rejected, (state, action) => {
            state.isLoading = false;
            console.error(
               "Error from downloadAttachment",
               action.error.message
            );
         })
   },
});

export const { setCGState, addFile, deleteFile, resetAllStates } =
   customerGroupSetupSlice.actions;

export default customerGroupSetupSlice.reducer;
